import React, { useState } from 'react';
import './MikrowispSyncModal.css';

const MikrowispSyncModal = ({ isOpen, onClose, onSync }) => {
  const [syncMode, setSyncMode] = useState('range'); // 'range' o 'single'
  const [startId, setStartId] = useState('');
  const [endId, setEndId] = useState('');
  const [singleId, setSingleId] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (syncMode === 'range') {
      const start = parseInt(startId);
      const end = parseInt(endId);
      
      if (!startId || !endId) {
        alert('Por favor ingresa el ID inicial y final');
        return;
      }
      
      if (isNaN(start) || isNaN(end)) {
        alert('Los IDs deben ser números válidos');
        return;
      }
      
      if (start > end) {
        alert('El ID inicial debe ser menor o igual al ID final');
        return;
      }
      
      if (end - start > 10000) {
        const confirm = window.confirm(
          `Estás intentando buscar ${end - start + 1} clientes. Esto puede tardar mucho tiempo.\n\n¿Deseas continuar?`
        );
        if (!confirm) return;
      }
      
      onSync({ mode: 'range', startId: start, endId: end });
    } else {
      const id = parseInt(singleId);
      
      if (!singleId) {
        alert('Por favor ingresa un ID');
        return;
      }
      
      if (isNaN(id) || id < 1) {
        alert('El ID debe ser un número válido mayor a 0');
        return;
      }
      
      // Advertencia si el ID es muy alto
      if (id > 10000) {
        const confirm = window.confirm(
          `Estás intentando buscar el ID ${id}.\n\nLos IDs muy altos pueden no existir.\n\n¿Deseas continuar?`
        );
        if (!confirm) return;
      }
      
      onSync({ mode: 'single', id });
    }
    
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="mikrowisp-sync-modal-overlay" onClick={onClose}>
      <div className="mikrowisp-sync-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mikrowisp-sync-modal-header">
          <h2>🔄 Sincronizar desde Mikrowisp</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>
        
        <form onSubmit={handleSubmit} className="mikrowisp-sync-form">
          <div className="sync-mode-selector">
            <label className="mode-option">
              <input
                type="radio"
                name="syncMode"
                value="range"
                checked={syncMode === 'range'}
                onChange={(e) => setSyncMode(e.target.value)}
              />
              <span>Buscar por rango de IDs</span>
            </label>
            <label className="mode-option">
              <input
                type="radio"
                name="syncMode"
                value="single"
                checked={syncMode === 'single'}
                onChange={(e) => setSyncMode(e.target.value)}
              />
              <span>Buscar solo un ID específico</span>
            </label>
          </div>

          {syncMode === 'range' ? (
            <div className="form-group">
              <label htmlFor="startId">ID Inicial:</label>
              <input
                type="number"
                id="startId"
                value={startId}
                onChange={(e) => setStartId(e.target.value)}
                placeholder="Ej: 1"
                min="1"
                required
              />
              <label htmlFor="endId" style={{ marginTop: '12px' }}>ID Final:</label>
              <input
                type="number"
                id="endId"
                value={endId}
                onChange={(e) => setEndId(e.target.value)}
                placeholder="Ej: 1000"
                min="1"
                required
              />
              <small className="form-hint">
                Buscará todos los clientes desde el ID inicial hasta el ID final (inclusive).
                <br />
                Ejemplo: De 1 a 1000 buscará 1000 clientes.
              </small>
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="singleId">ID del Cliente:</label>
              <input
                type="number"
                id="singleId"
                value={singleId}
                onChange={(e) => setSingleId(e.target.value)}
                placeholder="Ej: 513"
                min="1"
                required
              />
              <small className="form-hint">
                Buscará solo el cliente con este ID específico.
                <br />
                Ejemplo: 513 buscará solo el cliente con ID 513.
              </small>
            </div>
          )}

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="sync-button"
            >
              🔄 Sincronizar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MikrowispSyncModal;

